module.exports = __webpack_public_path__ + "static/media/Royal Enfield Himalayan.8ce1bec7.png";